import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { DocumentService } from 'src/app/Service/document/document.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { process } from '@progress/kendo-data-query';
import { IDocumentListInputModel } from 'src/app/ViewModel/DocumentModel';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { IMsgListInputModel } from 'src/app/ViewModel/CommunicationModel';
import * as moment from 'moment';
import { IPorjectInputModel } from 'src/app/ViewModel/ScheduleDefinitionModel';
import { IScheduleDocInfo } from 'src/app/ViewModel/ScheduleDocumentModel';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';

@Component({
  selector: 'app-document-message-view',
  templateUrl: './document-message-view.component.html',
  styleUrls: ['./document-message-view.component.css']
})
export class DocumentMessageViewComponent implements OnInit {

  public documentList!: any[];
  public mySelection: string[] = [];
  public gridView: any[] = [];
  public gridView1: any[] = [];
  public selectionAction: any[] = [];
  public currentPage!: string;
  public selecte_documentView: boolean = false;
  public LastViewingRecords = 30;
  public docType: string = '';
  projectId!: number;
  groupId!: number;
  memberId!: number ;
  projectCode!: string ;
  public skip: number = 0;
  public RDDocList : any;
  public SDDocList : any;
  public MSGList : any;

  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  @ViewChild(DataBindingDirective) directive!: DataBindingDirective;
  @ViewChild('docgrid') docGrid: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DocumentMessageViewComponent>,
    public communicationService: CommunicationService,
    private encryptDecryptService: EncryptDecryptService,
    private docService: DocumentService,
    private scheduleDocService: ScheduleDocumentService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.currentPage = this.data.type;
    this.projectId = this.commonService.getProjectId();
    this.projectCode = this.commonService.getProjectCode();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.docType = 'RD';
    this.getGridData();
  }

  async getGridData() {

    if (this.data.type == "Select Document") {
      this.selecte_documentView = true;
      let inputModel: IDocumentListInputModel = {
        projectId: this.commonService.getProjectId(),
        groupId: this.commonService.getLoggedInUserGroupId(),
        memberId: this.commonService.getLoggedInUserId(),
        transType: 'MyDocuments',
        createdFromDays: 0,
        docId: null,
        docNo: null,
        revisionNo: null
      }
      this.documentList = await this.docService.getDocumentList(inputModel).toPromise();
      this.documentList = this.documentList.map((x, index) => {
        return {
          itemIndex: index,
          docId: x.docId,
          documentNo: x.documentNo,
          title: x.title,
          revision: x.revision,
          authorisedByName: x.authorisedByName,
          createdByName: x.createdBy
        }
      });
      if (!!this.data.data) {
        let documentList = this.documentList.filter(data => {
          let result: boolean = true;
          for (let eleIndex = 0; eleIndex < this.data.data.length; eleIndex++) {
            let element: any = this.data.data[eleIndex];
            if (data.docId == element.docId && data.revision == element.revision) {
              result = false;
              break /*Once record match occured, break the inner loop*/
            }
          }
          return result;
        });
        this.gridView = documentList;
      }
      else {
        this.gridView = this.documentList;
      }

      this.RDDocList = this.gridView ;
    }
    else {
      this.selecte_documentView = false;
      var toDate = new Date(this.getDateFormat());
      let lastViewingDate = moment().add(-this.LastViewingRecords, 'days');
      var fromDate = new Date(lastViewingDate.toDate());
      let reqData: IMsgListInputModel = {
        transType: "MyMessages",
        projectId: this.commonService.getProjectId(),
        groupId: this.commonService.getLoggedInUserGroupId(),
        memberId: this.commonService.getLoggedInUserId(),
        mailBoxType: null,
        isConfidential: null,
        sentType: this.LastViewingRecords == 0 ? null : 'Sent',
        sentFrom: this.LastViewingRecords == 0 ? null : fromDate,
        sentTo: this.LastViewingRecords == 0 ? null : toDate,
        messageId: null,
        messageNo: null
      };
      this.documentList = await this.communicationService.GetMessageList(reqData).toPromise();
      if (!!this.data.data) {
        let documentList = this.documentList.filter(data => {
          let result: boolean = true;
          for (let eleIndex = 0; eleIndex < this.data.data.length; eleIndex++) {
            let element: any = this.data.data[eleIndex];
            if (data.messageId == element.messageId) {
              result = false;
              break /*Once record match occured, break the inner loop*/
            }
          }
          return result;
        });

        this.gridView1 = documentList;
      } else {
        this.gridView1 = this.documentList;
      }

      this.MSGList = this.gridView1 ;
    }

  }


  loadscheduleDocuments() {
    let inputModel: IPorjectInputModel = { project_Id: this.projectId, group_Id: this.groupId };

    inputModel.latestRecords_Count = 0;
    if (this.commonService.hasRequestedObject()) {
      var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
      inputModel.docId = requestedObject['inputDocId'];
      inputModel.revisionNo = requestedObject['inputRevNo'];
    }
    if (this.commonService.hasSearchedObject()) {
      var searchedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('searchedObject')));
      inputModel.docNo = searchedObject['searchDocNo'];
      inputModel.revisionNo = searchedObject['searchRevNo'];
    }
    this.scheduleDocService.GetScheduleDocList(inputModel).subscribe((res: IScheduleDocInfo[]) => {
      res.forEach(x => x.isSelected = false)
      if(this.selectionAction.length>0){
        this.selectionAction.forEach(x => x.isSelected = true)
      }
      this.documentList = res.map((x, index) => {
        let document: any = {
          itemIndex: index,
          docId: x.doc_Id,
          revision: x.revision_No,
          documentNo: x.doc_No,
          title: x.doc_Title,
          createdBy: x.created_By,
        };
        return document;
      });

      if (!!this.data.data) {
        let documentList = this.documentList.filter(data => {
          let result: boolean = true;
          for (let eleIndex = 0; eleIndex < this.data.data.length; eleIndex++) {
            let element: any = this.data.data[eleIndex];
            if (data.docId == element.docId && data.revision == element.revision) {
              result = false;
              break /*Once record match occured, break the inner loop*/
            }
          }
          return result;
        });
        this.gridView = documentList;
      }
      else {
        this.gridView = this.documentList;
      }
      this.SDDocList = this.gridView ;
      this.dataBinding.skip = 0;
    });



  }

  getDateFormat() {
    let today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();

    let today1 = dd + '-' + mm + '-' + yyyy;

    return today1;
  }


  public onFilterRD(inputValue: string): void {
    this.gridView = process(this.RDDocList, {
      filter: {
        logic: "or",
        filters: [
          {
            field: 'documentNo',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'title',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'revision',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'createdBy',
            operator: 'contains',
            value: inputValue
          },

        ],
      }
    }).data;
    this.dataBinding.skip = 0;
  }


  public onFilterSD(inputValue: string): void {
    this.gridView = process(this.SDDocList, {
      filter: {
        logic: "or",
        filters: [
          {
            field: 'documentNo',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'title',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'revision',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'createdBy',
            operator: 'contains',
            value: inputValue
          },

        ],
      }
    }).data;
    this.dataBinding.skip = 0;
  }

  public onFilterMSG(inputValue: string): void {
    this.gridView = process(this.MSGList, {
      filter: {
        logic: "or",
        filters: [
          {
            field: 'messageNumber',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'messageSubject',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'from',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'messageTypeDesc',
            operator: 'contains',
            value: inputValue
          },

        ],
      }
    }).data;
    this.dataBinding.skip = 0;
  }
  onSelectionChangeRD(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
              element.dataItem.isSelected = true;
              this.selectionAction.push(element.dataItem);
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { docId: any; revision: any; }; }) => {
        for (let i = 0; i < this.selectionAction.length; i++) {
          if (element.dataItem.docId == this.selectionAction[i].docId && element.dataItem.revision == this.selectionAction[i].revision) {
            this.selectionAction.splice(i, 1);
          }
        }
      });
    }
  }

  onSelectionChangeSD(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {       
              element.dataItem.isSelected = true;
              this.selectionAction.push(element.dataItem);           
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { docId: any; revision: any; }; }) => {
        for (let i = 0; i < this.selectionAction.length; i++) {
          if (element.dataItem.docId == this.selectionAction[i].docId && element.dataItem.revision == this.selectionAction[i].revision) {
            this.selectionAction.splice(i, 1);
          }
        }
      });
    }
  }

  onSelectionChangeMSG(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {       
          element.dataItem.isSelected = true;
          this.selectionAction.push(element.dataItem);       
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { messageId: any; }; }) => {
        for (let i = 0; i < this.selectionAction.length; i++) {
          if (element.dataItem.messageId == this.selectionAction[i].messageId) {
            this.selectionAction.splice(i, 1);
          }
        }
      });
    }
  }

  closeDialog() {
    this.dialogRef.close(this.selectionAction);
  }

  postData() {
    this.closeDialog();
  }
  onDocTypeChange(value: string) {
    this.docType = value;
    if (this.docType == 'SD') {
      this.loadscheduleDocuments();
    }
    if (this.docType == 'RD') {
      this.getGridData();
    }

  }
}
